import { createAction, props } from '@ngrx/store';

export const loadDirectDebitConfig = createAction(
  '[Complete Order] Load Direct Debit Autofill',
  props<{ payload?: { reuse_dd_details: boolean; payment_token?: string } }>()
);

export const resetDirectDebitConfig = createAction(
  '[Complete Order] Reset Direct Debit Config'
);

export type DirectDebitConfigActions =
  | typeof loadDirectDebitConfig
  | typeof resetDirectDebitConfig;
